<script lang="ts" setup>
import Gallery, {
  GalleryInstance,
} from "@/components/mobile/media/Gallery.vue";
import { computed, Ref, ref } from "vue";
import { Media, Task } from "@/types/entity";
import { entityStoreFactory } from "@/stores/factory/entity-store-factory";
import { cursorPagerStoreFactory } from "@/stores/factory/list-store-factory";
import api from "@/modules/api";

const cursorEncoderById = (task: Task, pointsToNextItems: boolean) => {
  return btoa(
    JSON.stringify({
      id: task.id,
      _pointsToNextItems: pointsToNextItems,
    })
  );
};

export interface StoryGalleryInstance {
  clear: (clearFilter?: boolean) => void;
  selectedMediaList: Ref<Media[]>;
}

const props = withDefaults(
  defineProps<{
    storyId: number;
    filter?: 1 | 2; // 1-图片；2-视频
    selectable?: boolean;
    enableUpload?: boolean;
    maxSelectCount?: number;
  }>(),
  {
    selectable: false,
    enableUpload: false,
    maxSelectCount: 1,
  }
);

const galleryRef = ref<GalleryInstance | null>(null);

const taskEntityState = entityStoreFactory<Task, "id">("id");
const { updateMap, getEntity } = taskEntityState;
const { dataList, fetchNewerList, fetchOlderList } = cursorPagerStoreFactory({
  entityStore: taskEntityState,
  fetch: async (cursor) => {
    const res = await api.readTaskPage({
      filter: {
        storyId: props.storyId,
        statusList: [0, 1],
      },
      sort: { field: "id", order: "desc" },
      cursor,
    });
    updateMap(res.page.data);
    return res.page.data;
  },
  cursorEncoder: cursorEncoderById,
});
const storyMediaList = computed<Media[]>(() => {
  return dataList.value.map((item) => item.entity.media as Media);
});

defineExpose<StoryGalleryInstance>({
  clear: (clearFilter?: boolean) => {
    galleryRef.value!.clear(clearFilter);
  }, // method: 刷新gallery列表
  selectedMediaList: computed(
    () => galleryRef.value?.selectedMediaList as Media[]
  ), // computed: 已选中的媒体列表
});
</script>
<template>
  <gallery
    ref="galleryRef"
    :media-list="storyMediaList"
    :on-pull-load="fetchNewerList"
    :on-scroll-load="fetchOlderList"
    v-bind="props"
  />
</template>
